import React, { useState } from 'react'
import Banner from '../components/Banner'
import axios from "axios";
import { FaLocationDot, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaXTwitter } from "react-icons/fa6";
import { Link } from 'react-router-dom';

const Contact = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        whatsapp: "",
        message: "",
        useSameNumber: false,
        honeypot: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Handle Input Change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
            ...(name === "phone" && prev.useSameNumber ? { whatsapp: value } : {}),
        }));

        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // Form Validation
    const validateForm = () => {
        let newErrors = {};
        if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required";
        if (!formData.email.includes("@")) newErrors.email = "Enter a valid email";
        if (!formData.phone.match(/^\d{9,}$/))
            newErrors.phone = "Enter a valid phone number";

        if (
            !formData.useSameNumber &&
            !formData.whatsapp.match(/^\d{9,}$/)
        )
            newErrors.whatsapp = "Enter a valid WhatsApp number";

        if (!formData.message.trim()) newErrors.message = "Message cannot be empty";
        if (formData.honeypot) newErrors.honeypot = "Bot detected! Submission blocked.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Submit Form
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsSubmitting(true);

        try {
            const response = await axios.post(
                process.env.REACT_APP_SERVER_URL + "api/contact/",
                {
                    name: formData.fullName,
                    email: formData.email,
                    mobile: formData.phone,
                    whatsapp: formData.whatsapp,
                    message: formData.message,
                },
                {
                    auth: {
                        username: process.env.REACT_APP_USERNAME,
                        password: process.env.REACT_APP_PASSWORD,
                    },
                }
            );

            if (response.status === 201) {
                alert("Message sent successfully!");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    whatsapp: "",
                    message: "",
                    useSameNumber: false,
                    honeypot: "",
                });
            }
        } catch (error) {
            alert("Error sending message. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main id="contact">

            <Banner img="assets/yachtimages/contact-banner.webp" text="Contact Us" />

            <section className="gap">
                <iframe
                    src="https://www.google.com/maps/embed/v1/place?q=Blue+Harbour+Yachts+Dubai+Marina+-+Dubai+-+United+Arab+Emirates&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                    width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </section>
            <section className="social-icons-section">
                <div>
                    <Link><FaFacebook className='icon' /></Link>
                    <Link to='https://www.instagram.com/blueharbouryachts/'><FaInstagram className='icon' /></Link>
                    <Link><FaEnvelope className='icon' /></Link>
                    <Link><FaXTwitter className='icon' /></Link>
                </div>
            </section>
            <section className="section-1">
                <div className="bg-image">
                    <div className="container">
                        <div className="row  justify-content-center">
                            <div className="col-md-4 mb-md-0 mb-3">
                                <div className="wrapper">
                                    <div className="icon-wrapper">
                                        {/* <i className="fa-solid fa-location-dot"></i> */}
                                        <FaLocationDot fontSize={30} />
                                    </div>
                                    <h4>ADDRESS</h4>


                                    <p><a href="https://www.google.co.in/maps/place/Blue+Harbour+Yachts/@25.077278,55.1367425,17z/data=!4m10!1m2!2m1!1shttps:%2F%2Fwww.google.com%2Fmaps%2Fembed%2Fv1%2Fplace%3Fq%3DBlue%2BHarbour%2BYachts%2BDubai%2BMarina%2B-%2BDubai%2B-%2BUnited%2BArab%2BEmirates%26key%3DAIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8!3m6!1s0x3e5f6d787a704b43:0x9766c8d0ba1a9e9!8m2!3d25.0772732!4d55.1393174!15sCpgBaHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS9tYXBzL2VtYmVkL3YxL3BsYWNlP3E9Qmx1ZStIYXJib3VyK1lhY2h0cytEdWJhaStNYXJpbmErLStEdWJhaSstK1VuaXRlZCtBcmFiK0VtaXJhdGVzJmtleT1BSXphU3lCRncwUWJ5cTl6VEZUZC10VVk2ZFpXVGdhUXp1VTE3UjgiA4gBAZIBDHlhY2h0X2Jyb2tlcuABAA!16s%2Fg%2F11kpwvxc_2?entry=ttu&g_ep=EgoyMDI1MDQyOS4wIKXMDSoASAFQAw%3D%3D">Dubai Marina - Dubai - United Arab Emirates</a></p>
                                </div>
                            </div>
                            <div className="col-md-4 mb-md-0 mb-3">
                                <div className="wrapper">
                                    <div className="icon-wrapper">
                                        <FaPhone fontSize={30} />
                                    </div>
                                    <h4>PHONE</h4>


                                    <p><a href="tel:+971 56 626 5785">+971 56 626 5785</a></p>
                                </div>
                            </div>
                            <div className="col-md-4 mb-md-0 mb-3">
                                <div className="wrapper">
                                    <div className="icon-wrapper">
                                        <FaEnvelope fontSize={30} />
                                    </div>
                                    <h4>EMAIL</h4>


                                    <p><a href="mailto:support@blueharbouryachts.com">support@blueharbouryachts.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <section className="contact-form-section gap">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-11">
                        <h2>Leave us your info </h2>
                        <p>
                            and we will get back to you.
                        </p>
                        <form className="form" onSubmit={handleSubmit}>
                            <div className="row mt-md-5 mt-3">
                                {/* Full Name */}
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Full Name*"
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                    />
                                    {errors.fullName && <small className="text-danger">{errors.fullName}</small>}
                                </div>

                                {/* Email */}
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Email*"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && <small className="text-danger">{errors.email}</small>}
                                </div>

                                {/* Phone Number */}
                                <div className="col-md-6 mb-3">
                                    <input
                                        type="text"
                                        className="form-control w-100 mb-3"
                                        placeholder="Mobile Number With Country Code"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                    {errors.phone && <small className="text-danger">{errors.phone}</small>}
                                </div>

                                {/* WhatsApp Number */}
                                <div className="col-md-6 mb-3">
                                    <input
                                        type="text"
                                        className="form-control w-100 mb-3"
                                        placeholder="WhatsApp number With Country Code"
                                        name="whatsapp"
                                        value={formData.useSameNumber ? formData.phone : formData.whatsapp}
                                        onChange={handleChange}
                                        disabled={formData.useSameNumber}
                                    />
                                    {errors.whatsapp && <small className="text-danger">{errors.whatsapp}</small>}
                                </div>

                                {/* Checkbox for Same WhatsApp Number */}
                                <div className="col-12 mb-3">
                                    <input
                                        type="checkbox"
                                        id="useSameNumber"
                                        name="useSameNumber"
                                        checked={formData.useSameNumber}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="useSameNumber" className="ms-2">
                                        Use the same phone number for WhatsApp
                                    </label>
                                </div>

                                {/* Message */}
                                <div className="col-12">
                                    <textarea
                                        className="form-control"
                                        placeholder="Message"
                                        rows="3"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>
                                    {errors.message && <small className="text-danger">{errors.message}</small>}
                                </div>

                                <input
                                    type="text"
                                    name="honeypot"
                                    value={formData.honeypot}
                                    onChange={handleChange}
                                    style={{ display: "none" }}
                                    tabIndex="-1"
                                    autoComplete="off"
                                />
                                {/* Submit Button */}
                                <div className="col-12">
                                    <button className="form-button" type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? "Submitting..." : "SUBMIT NOW"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

        </main>
    )
}

export default Contact